export enum EntityStoreKey {
  TellentOrganization = 'TellentOrganization',
}

export type DeleteOrgPayload = {
  code: string;
};
